var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 40,
    viewBox: "0 0 145 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.344 40H15.4L0.336 0.799997H9.352L19.04 27.176L28.728 0.799997H37.464L22.344 40ZM41.9331 0.799997H50.3331V32.104H63.9971V40H41.9331V0.799997ZM82.3572 0.799997H89.8052L105.541 40H96.7492L93.4452 31.544H78.4932L75.1892 40H66.5652L82.3572 0.799997ZM85.9412 11.496L81.0692 24.32H90.9252L85.9412 11.496ZM143.336 20.4C143.336 31.432 134.376 40 123.4 40H110.128V0.799997H123.4C134.376 0.799997 143.336 9.368 143.336 20.4ZM134.712 20.4C134.712 13.904 129.672 8.696 123.176 8.696H118.528V32.104H123.176C129.672 32.104 134.712 26.896 134.712 20.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2b7ade2ff1b0a708f370103aaa4b9fd8.svg";
export { ForwardRef as ReactComponent };